/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { UseMasterData } from '../model/masterData.model'
import { fetchMasterData } from '../store/masterData.reducer'
import {
  selectNationalities,
  selectMasterDataLoading,
  selectMasterDataError,
  selectSegments,
} from '../store/masterData.selectors'

import { selectDealer } from '~/agent/store/agent.selectors'
import { selectLineType } from '~/sale/store'

export default function useMasterData(): UseMasterData {
  const dispatch = useDispatch()
  const nationalities = useSelector(selectNationalities)
  const loading = useSelector(selectMasterDataLoading)
  const error = useSelector(selectMasterDataError)
  const segments = useSelector(selectSegments)
  const lineType = useSelector(selectLineType)
  const dealerId = useSelector(selectDealer)

  useEffect(() => {
    if (!nationalities?.length && !loading && !error && dealerId && lineType) {
      dispatch(fetchMasterData({ dealerId, subscriptionType: lineType }))
    }
  }, [dealerId, lineType])

  return { nationalities, loading, error, segments }
}
